import { UncontrolledNumberInputField, UncontrolledNumberInputFieldProps } from '@mews-commander/form';
import { useLocalizeCurrency } from '@mews/framework';

type Props = {
    defaultCurrencyCode: string;
    isDirty?: boolean;
} & UncontrolledNumberInputFieldProps;

export const PriceInput = ({ defaultCurrencyCode, isDirty, size, ...props }: Props) => {
    const localizeCurrency = useLocalizeCurrency();

    return (
        <UncontrolledNumberInputField
            placeholder={isDirty ? '' : localizeCurrency(0, defaultCurrencyCode)}
            suffix={defaultCurrencyCode}
            type="number"
            required
            {...props}
        />
    );
};
